import { EnvironmentProviders, inject, Injectable, makeEnvironmentProviders } from "@angular/core";

import { Observable } from "rxjs";
import {
  LktCustomSelectDataSource,
  LktSelectCategory,
  LktSelectGrade,
  LktSelectNetwork,
  LktSelectProfile,
  LktSelectSchoolData,
  LktSelectTagPage
} from "@frontends-v3/design-system";

import { CategoryService } from "../services/core/category.service";
import { GradeService } from "../services/core/grade.service";
import { NetworkService } from "../services/core/network.service";
import { ProfileService } from "../services/core/profile.service";
import { SchoolService } from "../services/core/school.service";
import { TagsService } from "../services/core/tag.service";

/** Opções dos selects especializados do design-system, obtidas pelos services do Lekto. */
@Injectable()
export class CustomSelectDataSource extends LktCustomSelectDataSource {
  private readonly categoryService = inject(CategoryService);
  private readonly gradeService = inject(GradeService);
  private readonly networkService = inject(NetworkService);
  private readonly profileService = inject(ProfileService);
  private readonly schoolService = inject(SchoolService);
  private readonly tagsService = inject(TagsService);

  public getCategories(): Observable<LktSelectCategory[]> {
    return this.categoryService.getCategoryFilterList();
  }

  public getGrades(): Observable<LktSelectGrade[]> {
    return this.gradeService.getGrades();
  }

  public getNetworks(): Observable<LktSelectNetwork[]> {
    return this.networkService.getFilterNetworkList();
  }

  public getSubNetworks(idNetwork: string): Observable<LktSelectNetwork[]> {
    return this.networkService.getFilterSubNetworkList(idNetwork);
  }

  public getSchools(idNetwork: string[], idSubNetwork: string[]): Observable<LktSelectSchoolData> {
    return this.schoolService.getSchoolSelectData(idNetwork, idSubNetwork);
  }

  public getProfiles(): Observable<LktSelectProfile[]> {
    return this.profileService.getProfiles();
  }

  public getTags(pageSize: number): Observable<LktSelectTagPage> {
    return this.tagsService.getTagFilterList("", "", { pageNumber: 1, pageSize });
  }
}

/** Liga os selects especializados do design-system (categoria, ano, rede, escola, perfil, tag) aos services. */
export function provideCustomSelectDataSource(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: LktCustomSelectDataSource, useClass: CustomSelectDataSource }
  ]);
}
